export type CommerceBrowserActivity = {
  action: "navigation" | "click" | "form_submit"
  path: string
}

async function postActivity(activity: CommerceBrowserActivity): Promise<{ bootstrap?: boolean } | null> {
  const response = await fetch("/api/vetpets/activity", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(activity),
    credentials: "same-origin",
    keepalive: true,
    cache: "no-store",
  })
  if (!response.ok) return null
  try {
    return (await response.json()) as { bootstrap?: boolean }
  } catch {
    return null
  }
}

export async function sendCommerceActivity(activity: CommerceBrowserActivity): Promise<void> {
  const first = await postActivity(activity)
  if (first?.bootstrap === true) {
    await postActivity(activity)
  }
}
